function popupNotification(message) {
  var success = $('.popup_flash.success');
  success.hide();
  success.fadeIn();
  success.find('.popup_flash_text').text(message);
  timestamp = new Date().getTime();
  success.attr('data-timestamp', timestamp);
  setTimeout(hidePopupNotification, 5000);
}

function popupAlert(message) {
  var alert = $('.popup_flash.alert');
  alert.hide();
  alert.fadeIn();
  alert.find('.popup_flash_text').text(message);
  timestamp = new Date().getTime();
  alert.attr('data-timestamp', timestamp);
  setTimeout(hidePopupAlert, 5000);
}

function hidePopupNotification(button) {
  var success = $('.popup_flash.success');
  timestamp = new Date().getTime();

  if (timestamp - success.attr('data-timestamp') >= 4950) {
    success.fadeOut();
  }
}

function hidePopupAlert(button) {
  var alert = $('.popup_flash.alert');
  timestamp = new Date().getTime();

  if (timestamp - alert.attr('data-timestamp') >= 4950) {
    alert.fadeOut();
  }
}

window.popupNotification = popupNotification;
window.popupAlert = popupAlert;
window.hidePopupNotification = hidePopupNotification;
window.hidePopupAlert = hidePopupAlert;
